<template>
    <footer class="footer">
        <div class="footer-top d-none d-xl-block">
            <v-container>
                <div class="d-flex justify-space-between align-start">
                    <client-gnb className="footer-gnb"></client-gnb>
                    <div class="lang">
                        <p class="lang_li">EN</p>
                        <a href="/" class="lang_li">KR</a>
                    </div>
                </div>
            </v-container>
        </div>

        <div class="footer-bottom">
            <v-container>
                <div class="d-xl-flex justify-space-between align-center">
                    <div class="d-lg-flex align-start mb-8 mb-lg-20 mb-xl-0">
                        <img src="/images/footer-ci.svg" alt="" class="d-block mb-30 mb-lg-0">
                        <div class="footer-info">
                            <p class="line-height-1 mb-8">IST</p>
                            <p>
                                C.E.O: J.H HWANG<span class="text-center d-none d-md-inline-block" style="width: 30px;">ㅣ</span><br class="mo">
                                Address: 673-10 Oppo-Ro, Opo-Eup, Gwangju-Si, Gyeonggi-Do, Korea 464-909<br>
                                TEL: +82-31-765-2268<span class="text-center d-none d-md-inline-block" style="width: 30px;">ㅣ</span><br class="mo">
                                FAX: +82-31-765-2389<span class="text-center d-none d-md-inline-block" style="width: 30px;">ㅣ</span><br class="mo">
                                Company Registration Number: 211-86-59880
                            </p>
                        </div>
                    </div>
                    <p>Copyright © 2022 IST. All Rights Reserved</p>
                </div>
            </v-container>
        </div>
    </footer>
</template>

<script>
import ClientGnb from "@/components/client/en/inc/client-gnb.vue";
export default {
    components: {
        ClientGnb,
    },
    data(){
        return {
            // site : null,
            // sites : [
            //     {
            //         name:"네이버",
            //         link:"https://www.naver.com/"
            //     },
            //     {
            //         name:"다음",
            //         link:"https://www.daum.net/"
            //     },
            // ]
        };
    },
    mounted(){
    },
    methods: {
        // changeD : function() {
        //     window.open(this.site, '_blank');
        // }
    }
}
</script>

<style scoped>
</style>
